import { render, staticRenderFns } from "./Unicorns.vue?vue&type=template&id=13a7082a&"
import script from "./Unicorns.vue?vue&type=script&lang=js&"
export * from "./Unicorns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports